import styled from 'styled-components';

interface ProductStatusTextProps {
  text: string;
}

export const ProductStatusText = ({ text }: ProductStatusTextProps) => {
  return (
    <Container>
      <Text>{text}</Text>
    </Container>
  );
};

const Container = styled.div`
  position: absolute;

  left: 50%;
  top: 50%;

  transform: translate(-50%, -50%);
`;

const Text = styled.span`
  color: var(--light-scheme-monochrome-black, #232429);
  text-align: center;
  font-family: Pretendard;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 85%; /* 20.4px */
  mix-blend-mode: darken;
  opacity: 0.6;
`;
